// Lib
// Types
import type { KpiType } from '@/lib/analytics/kpis/kpi.type';
import { outboundClicksConfig } from '@/lib/analytics/kpis/pinterest/outboundClicks';

import { KPIDefault } from '@/components/base/Kpi/KpiDefault';
// Components
import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';

export const mediaViewerOutboundClicksConfig: KpiType<
    typeof MediaViewerKpiLoader,
    typeof KPIDefault
> = {
    ...outboundClicksConfig,
    tooltip: null,
    loader: MediaViewerKpiLoader
};
